import CPageModule from '../../../components/CPageModule';
import CButton from '../../../components/CButton';
import { Add } from '@mui/icons-material';
import React from 'react';
import { type I3DPlotState } from '../../../models/calculator/I3DPlotStateModel';
import { type I3DPlotConfig } from '../../../models/calculator/I3DPlotConfigModel';
import type { IResponse } from '../../../models/IResponse';
import type { IOptionsCalculatorConfig } from '../../../models/IOptionsCalculatorConfig';
import type { IAutocompleteOption } from '../../../models/IAutocompleteOption';
import CLocalizedTextString from '../../../components/CLocalizedTextString';
import CCalculator3dPlot from './CCalculator3dPlot';

interface Props {
  plots: I3DPlotState[];
  optionsTableDerivatives: IResponse<{ options: Array<{ label: string, value: string }> }>;
  optionsConfigDefault: IOptionsCalculatorConfig;
  optionsConfigInput: IOptionsCalculatorConfig;
  optionsConfigLoaded: IOptionsCalculatorConfig;
  parameterOptions: IAutocompleteOption[];
  maxPlots: number;
  addPlot: () => void;
  deletePlot: (plotId: string) => void;
  updatePlotConfig: (plotId: string, configUpdate: Partial<I3DPlotConfig>) => void;
}

export default function CCalculator3dPlotManager(props: Props) {

  const dictTitle = CLocalizedTextString('topics.calculator.plot3d.desc');
  const dictPrefix = CLocalizedTextString('topics.calculator.twoDimPlot.plotNumber.prefix');
  const dictSuffix = CLocalizedTextString('topics.calculator.twoDimPlot.plotNumber.suffix');
  const textPrefix = `${dictTitle} ${props.plots.length > 1 ? dictPrefix : ''}`;
  const textSuffix = `${props.plots.length > 1 ? dictSuffix : ''}`;

  return (<>
    <CPageModule fullWidth style={{paddingBottom: 0}}>
      <CPageModule fullWidth submodule apiRequestState={props.optionsTableDerivatives.state}
                   showContent={!!props.optionsTableDerivatives.data}>
        {props.plots.map((plot, index) => (
          <CCalculator3dPlot
            key={plot.config.id}
            optionsTableDerivatives={props.optionsTableDerivatives}
            plot3d={plot.data}
            parameterOptions={props.parameterOptions}
            plotConfig={plot.config}
            showDeleteButton={props.plots.length > 1}
            onUpdatePlotConfig={(configUpdate) => {
              props.updatePlotConfig(plot.config.id, configUpdate);
            }}
            onDeletePlot={() => {
              props.deletePlot(plot.config.id);
            }}
            plotIndex={index}
            textPrefix={textPrefix}
            textSuffix={textSuffix}
            optionsConfigDefault={props.optionsConfigDefault}
            optionsConfigLoaded={props.optionsConfigLoaded}
            optionsConfigInput={props.optionsConfigInput}
          />))}
        <CPageModule submodule>
          <CButton onClick={props.addPlot} submodule disabled={props.plots.length >= props.maxPlots}
                   icons={{ start: <Add /> }} style={{borderWidth: 1}} isForm>
            {CLocalizedTextString('topics.calculator.threeDimPlot.addButton')}
          </CButton>
        </CPageModule>
      </CPageModule>
    </CPageModule>
  </>);
}